import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { AcceptableInvitationResponseSchema } from './acceptable-invitation-response.dto';
export const AcceptableSsoInvitationResponseSchema = AcceptableInvitationResponseSchema.omit({
    ePrivateKeyByInvitationSecret: true,
}).extend({
    ePrivateKeyBySsoSecret: z.string(),
    eSsoSecretByDomainKey: z.string().nullish(),
});
export class AcceptableSsoInvitationResponseDto extends createZodDto(AcceptableSsoInvitationResponseSchema) {
}
